var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`loader-${_vm.type}`},[_c('div',{staticClass:"loader"}),_vm._v(" "),(_vm.text)?_c('div',{class:['loader-text', `loader-text-${_vm.type}`]},[_c('div',{class:['text', `${_vm.font}`]},[_c('span',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }